<template>
    <a-flex class="line-flex-profile" justify="space-between">
        <a-col :span="11">
            <a-col :span="20" class="label-form-portal" >Identificación</a-col>
            <a-col class="custom-input-wrapper">
                <div>{{ userIdent }}</div>
            </a-col>
        </a-col>
        <a-col :span="11">
            <a-col :span="20" class="label-form-portal" >Tipo Cliente</a-col>
            <a-col class="custom-input-wrapper">
                <div>{{ typeClient }}</div>
            </a-col>
        </a-col>
    </a-flex >
    <a-flex class="line-flex-profile" justify="space-between">
        <a-col :span="24">
            <a-col :span="20" class="label-form-portal" >Dirección Principal</a-col>
            <a-col class="custom-input-wrapper" :style="{ height: '80px' }">
                {{ this.profileData.contact_address }}
            </a-col>            
        </a-col>
    </a-flex>
    <a-flex class="line-flex-profile" justify="space-between">
        <a-col :span="11">
            <a-col :span="20" class="label-form-portal" >Teléfono Móvil</a-col>
            <a-col class="custom-input-wrapper">
                <div>{{ phone(profileData.mobile) }}</div>
            </a-col>
        </a-col>
        <a-col :span="11">
            <a-col :span="20" class="label-form-portal" >Teléfono Fijo</a-col>
            <a-col class="custom-input-wrapper">
                <div>{{ phone(profileData.phone) }}</div>
            </a-col>
        </a-col>
    </a-flex>
    <a-divider class="profile_divider" style="margin-bottom: 1em;" />
    <a-row align="center">
        <a-typography-title :level="5">ACCIONES</a-typography-title>
    </a-row>
    <a-divider class="profile_divider" style="margin-bottom: 1em;" />
    <a-flex class="line-flex-profile" justify="space-between"  wrap="wrap">
        <!-- <a-button class="button-action-profile" @click="openImagePicker">Cambiar foto</a-button> -->
        <a-button class="button-action-profile" >Cambiar Contraseña</a-button>
        <!-- <a-button class="button-action-profile">Pagar Servicios</a-button> -->
        <a-button class="button-action-profile" @click="logout">Salir</a-button>
        <input type="file" ref="imagePicker" @change="uploadImage" style="display: none;" />
    </a-flex>
</template>
<script>
import { defineComponent } from 'vue';
import { logout } from '@/plugins/odoo';
export default defineComponent({
    props: {
        profileData: {
            type: Object,
            required: true
        }
    },
    mounted() {
        // console.log(this.$route.meta)
    },
    methods: {
        logout,
        phone(myPhone) {
            if (myPhone) {
                return myPhone
            } else {
                return "NO POSEE"
            }
        },
        openImagePicker() {
            this.$refs.imagePicker.click()
        },
        uploadImage(event) {
            const file = event.target.files[0]
            const reader = new FileReader()
            reader.onload = () => {
                this.base64Image = reader.result
            }
            reader.readAsDataURL(file)
        }
    },
    computed: {
        userIdent() {
            if (this.profileData.vat !== '') {
                return this.profileData.vat
            } else {
                return this.profileData.cedula
            }
        },
        typeClient() {
            if (this.profileData.vat !== '') {
                switch(this.profileData.vat[0]) {
                    case "V":
                    case "E":
                        return "Persona Natural"
                    case "J":
                        return "Persona Juridica"
                    case "G":
                        return "Ente Gubernamental"
                    case "P":
                        return "Otras Organizaciones"
                }
            } else {
                return "Natural"
            }
        },
        address_client() {
            const address = [
                this.profileData.sector ? this.profileData.sector : '',
                this.profileData.street ? this.profileData.street : '',
                this.profileData.street2 ? this.profileData.street2 : '',
                this.profileData.urban ? this.profileData.urban : '',
                this.profileData.street3 ? this.profileData.street3 : '',
                this.profileData.house_number ? this.profileData.house_number : '',
                this.profileData.address_reference_point ? this.profileData.address_reference_point : ''
            ]
            .filter(part => part.trim() !== '')
            .join(' ')
            .toUpperCase();
            return address
        }
    }
})
</script>
<style>
.custom-input {
  border: none;
  outline: none;
  background-color: transparent;
  font-size: 14px;
  width: 100%;
}
.custom-input-wrapper {
    display: inline-block;
    width: 100%;
    padding: 4px 11px;
    font-size: 14px;
    line-height: 1.5715;
    color: rgba(0, 0, 0, 0.85);
    background-color: #fff;
    background-image: none;
    border: 1px solid rgb(217, 217, 217);
    border-radius: 6px;
    transition: all 0.3s;
    font-weight: 400;
    height: 40px;
    margin: 0px;    
    position: relative;
    padding-block: 8px;
}
.line-flex-profile {
    margin-bottom: 1em;
}
.button-action-profile {
    width: 18vh;
    margin-bottom: 1em;
}
</style>